




































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import BasicMobileFullModal from '~/components/modals/BasicMobileFullModal.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import ProfileRunsDateFilter from '~/components/partials/ProfileRunsDateFilter.vue';
import LabelsPicker from "~/components/partials/LabelsPicker.vue";
import SportsDropdown from "~/components/partials/SportsDropdown.vue";

@Component({
  components: { SportsDropdown, LabelsPicker, BasicMobileFullModal, CheckInput, ProfileRunsDateFilter },
})
export default class LocalisationEventsMobileModal extends Vue {
  @Prop({ type: Array, default: () => [] }) value : Array<number | string>;
  @Prop(Array) sports: [];
  @Prop(Array) labels: [];
  @Prop(Array) eventTypes: [];
  @Prop(Boolean) selectPastEvents: false;

  @Watch('value')
  watch () {
    this.$emit('input', this.value);
  }
}
